module.exports = __webpack_public_path__ + "img/kredit.10f5ef98.svg";